import { UpdateKeyValueRequest } from "@models/base/updateKeyValueRequest.model";

export class UpdateTipoAjusteContratoRequest extends UpdateKeyValueRequest {
  public acronimo!: string
}
